import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from 'components/Page/Dashboard';
import TournamentFormat from 'components/Play/Tournament/Edit/TournamentFormat';

const Step2 = ({ match }) => (
  <Page showNavigation={false}>
    <TournamentFormat edit={match.path.includes('edit')} />
  </Page>
);

Step2.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Step2);
